<template>
    <div class='facets'>
        <see-all-options :filterResults='filterResults'></see-all-options>
        <h5><strong>Filter by</strong></h5>
        <hr>
        <!--Catalog-->
        <div>
            <h6 class='clickable' @click='manager.toggleOpen("catalog")'>
                Catalog
                <span class='pull-right' v-show='manager.filters.catalog.open'>
                    <img src="/images/facet_toggle_arrow.svg">
                </span>
                <span class='pull-right' v-show='!manager.filters.catalog.open'>
                    <img src="/images/facet_toggle_arrow.svg" class='rotate90'>
                </span>
            </h6>
            <transition name='slide'>
                <div v-show='manager.filters.catalog.open'>
                    <div>
                        <input @change='filterResults' v-model='manager.filters.catalog.selected' value='Archives' id='archives' type="checkbox"/>
                        <label for='archives'></label> <label for='archives'>Archives</label>
                    </div>
                    <div>
                        <input @change='filterResults' v-model='manager.filters.catalog.selected' value='Collections' id='collection' type="checkbox"/>
                        <label for='collection'></label> <label for='collection'>Collections</label>
                    </div>
                    <div>
                        <input @change='filterResults' v-model='manager.filters.catalog.selected' value='Collections NOAA' id='collection_noaa' type="checkbox"/>
                        <label for='collection_noaa'></label> <label for='collection_noaa'>Collections NOAA</label>
                    </div>
                    <div>
                        <input @change='filterResults' v-model='manager.filters.catalog.selected' value='Library' id='library' type="checkbox"/>
                        <label for='library'></label> <label for='library'>Library</label>
                    </div>
                </div>
            </transition>
            <hr>
        </div>

        <!--Online Media-->
        <div>
            <h6 class='clickable' @click='manager.toggleOpen("media")'>
                Online Media
                <span class='pull-right' v-show='manager.filters.media.open'>
                    <img src="/images/facet_toggle_arrow.svg">
                </span>
                <span class='pull-right' v-show='!manager.filters.media.open'>
                    <img src="/images/facet_toggle_arrow.svg" class='rotate90'>
                </span>
            </h6>
            <transition name='slide'>
                <div v-show='manager.filters.media.open'>
                    <media-options :filterResults='filterResults'></media-options>
                </div>
            </transition>
            <hr>
        </div>

        <!--Type-->
        <div>
            <h6 class='clickable' @click='manager.toggleOpen("type")'>
                Object
                <span class='pull-right' v-show='manager.filters.type.open'>
                    <img src="/images/facet_toggle_arrow.svg">
                </span>
                <span class='pull-right' v-show='!manager.filters.type.open'>
                    <img src="/images/facet_toggle_arrow.svg" class='rotate90'>
                </span>
            </h6>
            <transition name='slide'>
                <div v-show='manager.filters.type.open'>
                    <facet-options :filterResults='filterResults' name='type'></facet-options>
                </div>
            </transition>
            <hr>
        </div>

        <!--Language-->
        <div>
            <h6 class='clickable' @click='manager.toggleOpen("language")'>
                Language
                <span class='pull-right' v-show='manager.filters.language.open'>
                    <img src="/images/facet_toggle_arrow.svg">
                </span>
                <span class='pull-right' v-show='!manager.filters.language.open'>
                    <img src="/images/facet_toggle_arrow.svg" class='rotate90'>
                </span>
            </h6>
            <transition name='slide'>
                <div v-show='manager.filters.language.open'>
                    <facet-options :filterResults='filterResults' name='language'></facet-options>
                </div>
            </transition>
            <hr>
        </div>

        <!--Places-->
        <div>
            <h6 class='clickable' @click='manager.toggleOpen("place")'>
                Places
                <span class='pull-right' v-show='manager.filters.place.open'>
                    <img src="/images/facet_toggle_arrow.svg">
                </span>
                <span class='pull-right' v-show='!manager.filters.place.open'>
                    <img src="/images/facet_toggle_arrow.svg" class='rotate90'>
                </span>
            </h6>
            <transition name='slide'>
                <div v-show='manager.filters.place.open'>
                    <facet-options :filterResults='filterResults' name='place'></facet-options>
                </div>
            </transition>
            <hr>
        </div>

        <!--Date-->
        <div>
            <h6 class='clickable' @click='manager.toggleOpen("date")'>
                Date
                <span class='pull-right' v-show='manager.filters.date.open'>
                    <img src="/images/facet_toggle_arrow.svg">
                </span>
                <span class='pull-right' v-show='!manager.filters.date.open'>
                    <img src="/images/facet_toggle_arrow.svg" class='rotate90'>
                </span>
            </h6>
            <transition name='slide'>
                <div class='date-height' v-show='manager.filters.date.open'>
                    <div class='date_facet'>
                        <label for='from_year'>From</label>
                        <input id='from_year'
                                type="text"
                                class='form-control'
                                placeholder='Year'
                                v-model='manager.filters.date.from_year'
                                @change.lazy='manager.checkYear(true)'/>
                        <label for='from_year_era' class='sr-only'>From Year Range</label>
                        <select id='from_year_era' class='form-control' v-model='manager.filters.date.from_era'>
                            <option value='AD/CE'>AD/CE</option>
                            <option value='BC/BCE'>BC/BCE</option>
                            <option value='BP'>BP</option>
                        </select>
                    </div>
                    <div class='date_facet'>
                        <label for='to_year'>To</label>
                        <input id='to_year'
                                type="text"
                                class='form-control'
                                placeholder='Year'
                                v-model='manager.filters.date.to_year'
                                @change.lazy='manager.checkYear(false)'/>
                        <label for='to_year_era' class='sr-only'>To Year Range</label>
                        <select id='to_year_era' class='form-control' v-model='manager.filters.date.to_era'>
                            <option value='AD/CE'>AD/CE</option>
                            <option value='BC/BCE'>BC/BCE</option>
                            <option value='BP'>BP</option>
                        </select>
                    </div>
                    <div class='date_facet'>
                        <button class='btn bg-blue pull-right' @click='filterResults'>Apply</button>
                    </div>
                </div>
            </transition>
            <hr>
        </div>

        <!--Exhibits-->
        <div>
            <h6 class='clickable' @click='manager.toggleOpen("exhibits")'>
                Exhibit
                <span class='pull-right' v-show='manager.filters.exhibits.open'>
                    <img src="/images/facet_toggle_arrow.svg">
                </span>
                <span class='pull-right' v-show='!manager.filters.exhibits.open'>
                    <img src="/images/facet_toggle_arrow.svg" class='rotate90'>
                </span>
            </h6>
            <transition name='slide'>
                <div v-show='manager.filters.exhibits.open'>
                    <facet-options :filterResults='filterResults' name='exhibits'></facet-options>
                </div>
            </transition>
            <hr>
        </div>
    </div>
</template>

<script>
    import FacetVue from './facet.vue'
    import MediaVue from './media.vue'
    import SeeAllOptionsVue from './seeAllOptions.vue'
    import EventHub from '../eventHub.js'
    import FilterManager from './../filterManager.js'

    export default {
        created: function () {
            var self = this
            EventHub.$on('filter-results', this.filterResults)
        },
        beforeDestroy: function () {
            EventHub.$off('filter-results')
        },
        components: {
            'see-all-options': SeeAllOptionsVue,
            'facet-options': FacetVue,
            'media-options': MediaVue,
        },
        data: function () {
            return {
                manager: FilterManager,
                see_all_facet: null
            }
        },
        methods: {
            findFilterNameByField: function (field) {
                for (var filter_name in this.manager.filters) {
                    if (this.manager.filters[filter_name].field == field) {
                        return filter_name
                    }
                }

                return ''
            },
            selectFilter: function (filter) {
                var name = this.findFilterNameByField(filter.field)
                if (name && typeof this.manager.filters[name] !== 'undefined') {
                    this.manager.filters[name].selected.push(filter.value)
                }

                EventHub.$emit('add-filter', filter)
            },
            filterResults: function () {
                var self = this
                var query = this.manager.generateQuery()

                // This is deep extend is important. Deep cloning the query object
                // prevents the route from sharing the same object.
                query = $.extend(true, {}, query)

                // Push new route (this will case the search results to be refreshed)
                this.$router.push({name: 'search', query: query})
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/variables.scss';

    .facets {
        white-space: nowrap;

        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 991px) {
            padding: 10px;
        }

        .sort {
            padding-bottom: 10px;
        }

        .date_facet {
            margin-bottom: 10px;

            label {
                width: 40px;
                text-align: left;
            }

            input {
                display: inline;
                width: 30%;
            }
            select {
                display: inline;
                width: 30%;
            }
        }
        .date-height {
            height: 123px;
        }

        h6 {
            white-space: normal; /* Fixes firefox pull-right*/
        }
    }
</style>
